"use strict";var e;Object.defineProperty(exports,"__esModule",{value:!0}),exports.SortDirection=void 0,(e=exports.SortDirection||(exports.SortDirection={})).DESC="desc",e.ASC="asc";
